import { CancelToken } from 'axios'
import apiInstance from '../../../backend-api.setup'
import { ApiPathConfig } from '../../../../config/ApiPathConfig'
import {
  CompareGroupType,
  StudyObjectGroupCompareEnum,
  StudyObjectType,
} from '../../../../../components/analytics-details-v2/view/readership-profile/configs/StudiesObjectsCompareGroupTypesConfig'
import NewReadershipProfileBookFiltersInterface from '../../../../interface/analytics/new-readership-profile-book-filters'
import { ReadershipProfilePreviewUsersInputInterface } from '../../../../interface/analytics/readership-profile-preview-users-input.interface'

export const postPrivateReadershipProfilePreviewService = (
  preview: {
    title: string
    studyObject: {
      type: StudyObjectType
      ids: string[] | number[]
      eans: number[]
    }
    compareGroup: {
      type: CompareGroupType
      ids: string[] | number[]
      eans: number[]
    }
    subject_book_filters: NewReadershipProfileBookFiltersInterface
    subject_users_filters: Omit<
      ReadershipProfilePreviewUsersInputInterface,
      'type'
    >
    comparison_book_filters: NewReadershipProfileBookFiltersInterface
    comparison_users_filters: Omit<
      ReadershipProfilePreviewUsersInputInterface,
      'type'
    >
  },
  studyFile?: File | null,
  compareFile?: File | null,
  cancelToken?: CancelToken,
) => {
  const formData = new FormData()
  formData.append('json_input', JSON.stringify(preview))
  if (studyFile) formData.append('subject_users_file', studyFile)
  if (compareFile) formData.append('comparison_users_file', compareFile)

  return apiInstance.post(ApiPathConfig.ANALYTICS_PRIVATE_PREVIEW, formData, {
    cancelToken,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
